import { Checkmark, Security } from '@carbon/icons-react';
import { defineMessages, useIntl } from 'react-intl';

import InfoCard from 'Components/Common/InfoCard/InfoCard';
import styles from './PaymentInfoCard.module.scss';

const PaymentInfoCard = () => {
    const intl = useIntl();

    return (
        <InfoCard
            illustration={<Security />}
            title={intl.formatMessage(messages.title)}
            className={styles.card}
            description={intl.formatMessage(messages.description)}
            items={[
                {
                    icon: <Checkmark size={20} />,
                    title: intl.formatMessage(messages.secureConnectionTitle),
                    description: intl.formatMessage(messages.secureConnectionDescription),
                },
                {
                    icon: <Checkmark size={20} />,
                    title: intl.formatMessage(messages.cardDataTitle),
                    description: intl.formatMessage(messages.cardDataDescription),
                },
                {
                    icon: <Checkmark size={20} />,
                    title: intl.formatMessage(messages.controlTitle),
                    description: intl.formatMessage(messages.controlDescription),
                },
            ]}
        />
    );
};

const messages = defineMessages({
    title: {
        id: 'src.Screens.Dashboard.InitialSetup.steps.PaymentStep.PaymentInfoCard.title',
        defaultMessage: 'Płatność jest bezpieczna',
    },
    description: {
        id: 'src.Screens.Dashboard.InitialSetup.steps.PaymentStep.PaymentInfoCard.description',
        defaultMessage: 'Dane karty są obsługiwane przez zabezpieczony protokół, więc możesz spokojnie dokończyć konfigurację bez obaw o ich bezpieczeństwo.',
    },
    secureConnectionTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.steps.PaymentStep.PaymentInfoCard.secureConnectionTitle',
        defaultMessage: 'Bezpieczne połączenie',
    },
    secureConnectionDescription: {
        id: 'src.Screens.Dashboard.InitialSetup.steps.PaymentStep.PaymentInfoCard.secureConnectionDescription',
        defaultMessage: 'Informacje płatnicze są przesyłane przez szyfrowane połączenie.',
    },
    cardDataTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.steps.PaymentStep.PaymentInfoCard.cardDataTitle',
        defaultMessage: 'Nie przechowujemy pełnych danych karty',
    },
    cardDataDescription: {
        id: 'src.Screens.Dashboard.InitialSetup.steps.PaymentStep.PaymentInfoCard.cardDataDescription',
        defaultMessage: 'W aplikacji zapisujemy tylko dane potrzebne do rozpoznania metody płatności.',
    },
    controlTitle: {
        id: 'src.Screens.Dashboard.InitialSetup.steps.PaymentStep.PaymentInfoCard.controlTitle',
        defaultMessage: 'Masz kontrolę',
    },
    controlDescription: {
        id: 'src.Screens.Dashboard.InitialSetup.steps.PaymentStep.PaymentInfoCard.controlDescription',
        defaultMessage: 'Metody płatności możesz później zmienić lub usunąć w ustawieniach subskrypcji.',
    },
});

export default PaymentInfoCard;
